export type PlanTab =
  | 'currentPlan'
  | 'planChange'
  | 'planCancel'
  | 'billingInfo';

export type BasicPlanInfo = {
  planName: string;
  planTerm: string | null;
  contractPeriodStart: string;
  contractPeriodEnd: string;
  canPostRecruitments: boolean;
  canUseLikes: boolean;
  likeLimit?: number | string;
  canUseScouts: boolean;
  scoutLimit?: number | string;
};

export type CurrentPlanInfo = BasicPlanInfo & {
  scheduledUpdateDate: string;
};

export type NextPlanInfo = BasicPlanInfo & {
  billingDate: string;
  amountBilled: string;
  paymentDueDate: string;
  monthlyFee?: string;
  contractPlanId?: number;
};

export type BillingInfo = {
  companyName: string;
  department: string;
  inCharge: string;
  zipCode01: string;
  zipCode02: string;
  address01: string;
  address02: string;
  email: string;
  emailSubFirst: string;
  emailSubSecond: string;
};

export type FetchCurrentNextPlanInfo = {
  currentPlanInfo: CurrentPlanInfo;
  nextPlanInfo: NextPlanInfo;
};

export type FetchPlanOptions = {
  nextPlanName: string;
  planOptions: NextPlanInfo[];
};

export type CancelledContents = {
  expiredAt: string;
  updateDeadlineAt: string;
  cancelledAt: string;
  recruitmentCount: number;
  eventCount: number;
  postCount: number;
  entryCount: number;
};

export type FetchIsCancelled = {
  isCancelled: boolean;
};

export type FetchCancelledContents = {
  cancelledContents: CancelledContents;
};

export type PostPlanReservation = {
  success: boolean;
  error?: string;
};

export type PostUpdateBillingInfo = PostPlanReservation;

export const cancelReasonList = [
  '採用するポジションがなくなった',
  '採用ニーズはあるが予算がなくなった',
  '人事の工数がかけられなくなった',
  '他のサービスに切り替える',
  'やむを得ない理由（事業統合・買収・倒産など）',
  'その他の理由'
];

export const satisfactionList = [
  '大変満足した',
  'やや満足',
  '普通',
  'やや不満',
  '不満足',
];

export const futureHiringNeedsList = [
  '現在も採用ニーズがある',
  '1-3ヶ月後',
  '3-6ヶ月後',
  '6-12ヶ月後',
  '1年以上先まで採用ニーズはない',
  '不明・欠員が発生したら',
];

export type CancelForm = {
  staffName: string;
  cancelReasons: string[];
  otherReason: string;
  rtfSatisfaction: string;
  salesSatisfaction: string;
  futureHiringNeeds: string;
  freeDescription: string;
};

export type PlanTerm = 'half' | 'year';

export const PLAN_CONFIG = {
  premier: {
    prices: { half: 150000, year: 140000 },
    planIds: { half: 14, year: 15 },
    label: 'プレミアプランで始める'
  },
  minimum: {
    prices: { half: 45000, year: 40000 },
    planIds: { half: 10, year: 11 },
    label: 'ミニマムプランで始める'
  },
  basic: {
    prices: { half: 80000, year: 75000 },
    planIds: { half: 12, year: 13 },
    label: 'ベーシックプランで始める'
  },
  short: {
    planId: 16,
    label: 'ショートプランで始める'
  },
  success: {
    planId: 8,
    label: '成功報酬プランで始める'
  }
};
